import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useTranslation } from "react-i18next";
import { LayoutDashboard, Scissors, CalendarDays, List, Settings, Code2, LogOut, Menu, X, Users } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import LanguageSwitcher from "@/components/LanguageSwitcher";

export default function Sidebar() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const links = [
    { to: "/", icon: LayoutDashboard, label: t("nav_dashboard") },
    { to: "/services", icon: Scissors, label: t("nav_services") },
    { to: "/staff", icon: Users, label: t("nav_staff") },
    { to: "/appointments", icon: List, label: t("nav_appointments") },
    { to: "/calendar", icon: CalendarDays, label: t("nav_calendar") },
    { to: "/settings", icon: Settings, label: t("nav_settings") },
    { to: "/widget", icon: Code2, label: t("nav_widget") },
  ];

  const handleLogout = () => { logout(); navigate("/login"); };

  return (
    <>
      <Button variant="ghost" size="icon" className="fixed top-4 left-4 z-50 lg:hidden text-white" onClick={() => setOpen(!open)} data-testid="sidebar-mobile-toggle">
        {open ? <X size={20} /> : <Menu size={20} />}
      </Button>
      {open && <div className="fixed inset-0 bg-black/60 z-40 lg:hidden" onClick={() => setOpen(false)} />}
      <aside className={`fixed lg:static inset-y-0 left-0 z-40 w-64 bg-slate-950/80 backdrop-blur-xl border-r border-slate-800 flex flex-col transition-transform lg:translate-x-0 ${open ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`} data-testid="sidebar">
        <div className="p-6 border-b border-slate-800">
          <h1 className="text-xl font-bold tracking-tight font-heading text-white">Book Flowy</h1>
          <p className="text-xs text-slate-500 mt-1 truncate">{user?.email}</p>
        </div>
        <nav className="flex-1 p-4 space-y-1 overflow-y-auto" data-testid="sidebar-nav">
          {links.map(({ to, icon: Icon, label }) => (
            <NavLink key={to} to={to} end={to === "/"} onClick={() => setOpen(false)}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 ${isActive ? "bg-indigo-500/10 text-indigo-400 border border-indigo-500/20" : "text-slate-400 hover:text-white hover:bg-white/5 border border-transparent"}`}
              data-testid={`sidebar-link-${label.toLowerCase()}`}>
              <Icon size={18} strokeWidth={1.5} />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-slate-800 space-y-1">
          <LanguageSwitcher />
          <button onClick={handleLogout} className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-slate-400 hover:text-red-400 hover:bg-red-500/5 transition-colors w-full" data-testid="logout-button">
            <LogOut size={18} strokeWidth={1.5} />{t("nav_logout")}
          </button>
        </div>
      </aside>
    </>
  );
}
